// routes
// eslint-disable-next-line
// @ts-nocheck
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import { store } from './store/index';
import { Provider } from 'react-redux';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <BaseOptionChartStyle />
        <Router />
      </ThemeProvider>
    </Provider>
  );
}
